import APIClient from '@/shared/http/clients/api.js'

const resourceName = 'REUsuarios'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAllCorretores = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/corretor?limit=${limit}&index=${index}`, data, config)
const GetAllClientes = (limit, index, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/cliente?limit=${limit}&index=${index}`, data, config)

const PostCorretor = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/corretor/adicionar`, data, config)
const PostCliente = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/cliente/adicionar`, data, config)

const PutCorretor = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/atualizar/corretor`, data, config)
const PutCliente = (data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/atualizar/cliente`, data, config)

const AprovarReprovarCorretor = (corretorId, aprovar, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/corretor/aprovar/${corretorId}/${aprovar}`, data, aprovar, config)
const DeleteCorretor = (corretorId, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/corretor/deletar/${corretorId}`, data, config)
const DeleteCliente = (clienteId, data, config = {}) => APIClient.delete(`${APIBaseURLRealEstate}/${resourceName}/cliente/deletar/${clienteId}`, data, config)
const ResetSenhaCorretor = (corretorId, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/corretor/redefinir/${corretorId}`, data, config)
const ResetSenhaCliente = (clienteId, data, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/cliente/redefinir/${clienteId}`, data, config)
const GetCorretoresByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/corretor/filtro?limit=${limit}&index=${index}`, data, config)
const GetClientesByFiltro = (limit, index, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/cliente/filtro?limit=${limit}&index=${index}`, data, config)
const GetEmpreendimentosByCliente = (clienteId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/cliente/empreendimentos/${clienteId}`, data, config)
const GetParcelasCliente = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/cliente/parcelas`, data, config)
const GetBoletosCliente = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/cliente/boletos`, data, config)
const DownloadBoleto = (clienteId, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/cliente/boleto/download/${clienteId}`, data, config)

const UploadInformeRendimento = (clienteId, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/cliente/comprovante/upload/${clienteId}`, data, {
  ...config,
  transformRequest: [(d, headers) => {
    delete headers['Content-Type']
    return d
  }]
})

const TrocarStatusCliente = (clienteId, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/cliente/trocar/status/${clienteId}`, data, config)
const TrocarStatusCorretor = (corretorId, data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/corretor/trocar/status/${corretorId}`, data, config)

const GetClienteByCpf = (cpf, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/cliente/cpf/${cpf}`, data, config)
const GetClienteByName = (nome, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/getByName/${nome}`, config)
const usermanagement = {
  GetAllCorretores,
  GetAllClientes,
  PostCorretor,
  PostCliente,
  PutCorretor,
  PutCliente,
  AprovarReprovarCorretor,
  DeleteCorretor,
  DeleteCliente,
  ResetSenhaCorretor,
  ResetSenhaCliente,
  GetCorretoresByFiltro,
  GetEmpreendimentosByCliente,
  GetParcelasCliente,
  GetBoletosCliente,
  DownloadBoleto,
  UploadInformeRendimento,
  GetClientesByFiltro,
  TrocarStatusCliente,
  TrocarStatusCorretor,
  GetClienteByCpf,
  GetClienteByName
}

export default usermanagement



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/usermanagement.js